<template>
    <div>
        <div v-if="!additionalContent.image_url">
            <!-- max. file size for upload is 10MB, but in Bytes 10485760 (binary) -->
            <!-- filepond maxFileSize works in decimal system so 10MB are 10000000 Bytes -->
            <!-- the maximum size must be increased to 11MB  to allow the upload of 10MB files. -->
            <file-pond
                name="image"
                ref="pond"
                label-idle="Hier klicken oder Bild reinziehen..."
                :allow-multiple="false"
                :accepted-file-types="acceptedFiles()"
                maxFileSize="11MB"
                :server="server"
                @processfile="afterUpload"
                :disabled="disabled"
            />
        </div>
        <div v-else>
            <br>
            <div class="row" style="display: flex; align-items: center">
                <div class="col-md-1">
                    <button class="btn btn-danger float-right" style="margin-top: 50%;" slot="browse-btn"
                            content="Bild entfernen"
                            @click="removeImage()"
                            :disabled="disabled"
                            v-tippy><i class="fa fa-trash"></i>
                    </button>
                </div>
                <div class="col-md-11">
                    <div style="display: flex; justify-content: center;  background: #eeeeee; border-radius: 15px "
                         @mousemove="handleMouseMove">
                        <video style="max-width: 100%; max-height: 300px" controls :src="additionalContent.image_url"
                               v-if="additionalContent.image_url.includes('.mov')
                               || additionalContent.image_url.includes('.mp4')
                               || additionalContent.image_url.includes('.webm')">
                        </video>
                        <div v-else style="position: relative; user-select: none;">
                            <img :src="additionalContent.image_url" style="max-width: 100%; max-height: 450px;"
                                 @mousemove="handleMouseMove" draggable="false" @mouseleave="handleMouseLeave"
                                 @mousedown="handleMouseDown" @mouseup="handleMouseUp">
                            <div v-if="typeof additionalContent.metadata !== 'undefined'">
                                <div class="verticalLineLeft"
                                     :style="'height: 100%; width: '+Math.round(additionalContent.metadata.computedWidth*0.1)+'px;'"></div>
                                <div class="horizontalLineTop"
                                     :style="'width: 100%; top: 0; height: '+Math.round(additionalContent.metadata.computedHeight*0.1)+'px;'"></div>
                                <div class="verticalLineRight"
                                     :style="'height: 100%; left: '+Math.round(additionalContent.metadata.computedWidth*0.9)+'px; width: '+Math.round(additionalContent.metadata.computedWidth*0.1)+'px;'"></div>
                                <div class="horizontalLineBottom"
                                     :style="'width: 100%; top: '+Math.round(additionalContent.metadata.computedHeight*0.9)+'px; height: '+Math.round(additionalContent.metadata.computedHeight*0.1)+'px;'"></div>
                            </div>
                            <div v-for="(product_mark,index) in additionalContent.product_marks"
                                 style="position: absolute; top: 0; left: 0">
                                <div class="product-mark"
                                     :style="'top:' + (product_mark.y -10)+ 'px; left: '+ (product_mark.x -10) + 'px;'">
                                    <div
                                        style="position:absolute; left:-35px; top:-25px; width: 90px; height: 22px; background: rgba(21,21,21,0.75); border-radius: 5px">
                                        <p style="color: white">{{ 'Markierung ' + (index + 1) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>

        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import vueFilePond, {setOptions} from "vue-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import de_DE from "filepond/locale/de-de"

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);

setOptions(de_DE)

export default {
    name: 'ContentPreviewAdditionalContent',
    components: {FilePond},
    props: ['index', 'disabled', 'additionalContent', 'channelIndex', 'scaleWidth', 'scaleHeight'],
    data() {
        return {
            files: [],
            server: {
                url: '/api/content-hub/image/upload',
                process: {
                    url: '',
                    method: 'POST',
                    withCredentials: true,
                    headers: {},
                    timeout: 60000,
                    ondata: (formData) => {
                        formData.append('id', this.record.id);
                        formData.append('client_id', this.record.client_id)
                        formData.append('scale_width', this.scaleWidth);
                        formData.append('scale_height', this.scaleHeight);
                        return formData;
                    },
                }
            },
        }
    },
    mounted() {
        this.getImageMetadata(true);
    },
    computed: {
        ...mapGetters({
            'channels': 'getChannels',
            'mediaType': 'getMediaType',
            user: 'getUser',
            record: 'getRecord'
        })
    },
    methods: {
        updateMetadata(event) {
            let metadata = this.additionalContent.metadata;
            if (!metadata) return;
            let bounds = event.target.getBoundingClientRect();
            metadata.imgBoundsX = bounds.x;
            metadata.imgBoundsY = bounds.y;
            metadata.imgMousePosX = event.clientX - metadata.imgBoundsX;
            metadata.imgMousePosY = event.clientY - metadata.imgBoundsY;

        },
        handleMouseMove(event) {
            for (let mark of this.additionalContent.product_marks) {
                mark.x += 0.0000000001;
                mark.y += 0.0000000001;
                mark.relative_x += 0.0000000001;
                mark.relative_y += 0.0000000001;
            }

            this.updateMetadata(event);

            let metadata = this.additionalContent.metadata;
            if (!metadata || !metadata.selectedMark) return;

            metadata.selectedMark.x = metadata.imgMousePosX;
            metadata.selectedMark.y = metadata.imgMousePosY;

            for (let mark of this.additionalContent.product_marks) {
                if (mark === metadata.selectedMark) {
                    mark.x = metadata.imgMousePosX;
                    mark.y = metadata.imgMousePosY;
                    mark.relative_x = mark.x / metadata.computedWidth;
                    mark.relative_y = mark.y / metadata.computedHeight;
                }
            }
        },
        handleMouseDown(event) {
            this.updateMetadata(event);

            let metadata = this.additionalContent.metadata;
            if (!metadata) return;

            for (let mark of this.additionalContent.product_marks) {
                let distance = Math.pow(metadata.imgMousePosX - mark.x + 2, 2) + Math.pow(metadata.imgMousePosY - mark.y + 2, 2);
                if (distance < 121) { //Square 11, because that is the marker radius, no need for sqrt
                    metadata.selectedMark = mark;
                    return;
                }
            }
        },
        handleMouseUp(event) {
            this.updateMetadata(event);
            let metadata = this.additionalContent.metadata;
            if (!metadata) return;

            metadata.selectedMark = null;
        },
        handleMouseLeave(event) {
            this.updateMetadata(event);
            let metadata = this.additionalContent.metadata;
            if (!metadata) return;

            metadata.selectedMark = null;
        },
        getImageMetadata(firstTime = false) {
            if (!this.additionalContent.metadata) {
                this.additionalContent.metadata = {
                    imgBoundsX: 0,
                    imgBoundsY: 0,
                    imgMousePosX: 0,
                    imgMousePosY: 0,
                    imgWidth: 0,
                    imgHeight: 0,
                    computedWidth: 200,
                    computedHeight: 200,
                    selectedMark: null,
                }
            }

            let metadata = this.additionalContent.metadata;
            if (this.additionalContent.image_url) {
                let image = new Image();
                image.onload = () => {
                    metadata.imgWidth = image.naturalWidth;
                    metadata.imgHeight = image.naturalHeight;
                    let scale = metadata.imgHeight > 450 ? 450 / metadata.imgHeight : 1.0;
                    metadata.computedWidth = image.width * scale;
                    metadata.computedHeight = image.height * scale;
                    if (!firstTime)
                        for (let mark of this.additionalContent.product_marks) {
                            mark.x = metadata.computedWidth * 0.5;
                            mark.y = metadata.computedHeight * 0.5;
                            mark.relative_x = 0.5;
                            mark.relative_y = 0.5;
                        }
                    this.$parent.$forceUpdate();
                    this.$forceUpdate();
                };
                image.src = this.additionalContent.image_url;
            }
        },
        acceptedFiles() {
            return 'image/jpeg, image/png, image/webp, video/mov, video/mp4, video/quicktime, video/webm';
        },
        isVideo(url) {
            return (url.includes('.mov') || url.includes('.mp4') || url.includes('.webm'))
        },
        removeImage() {
            this.additionalContent.image_url = null;
        },
        afterUpload(error, file) {
            const response = JSON.parse(file.serverId);
            console.log(file);
            this.additionalContent.image_url = response.content_url;

            this.getImageMetadata();

            this.$parent.$forceUpdate();

            this.$forceUpdate();

            this.$emit('update:channels', this.channels)
        },
        triggerFileUploader() {
            document.getElementById("file").click()
        }
    }
}
</script>

<style scoped>
</style>
<style>
.verticalLineRight {
    border-left: 2px dashed #931e1e;
    position: absolute;
    width: 1px;
    top: 0;
    background-color: rgba(217, 122, 122, 0.4);
}

.verticalLineLeft {
    border-right: 2px dashed #931e1e;
    position: absolute;
    width: 1px;
    top: 0;
    background-color: rgba(217, 122, 122, 0.4);
}

.horizontalLineTop {
    border-bottom: 2px dashed #931e1e;
    position: absolute;
    height: 1px;
    left: 0;
    background-color: rgba(217, 122, 122, 0.4);
}

.horizontalLineBottom {
    border-top: 2px dashed #931e1e;
    position: absolute;
    height: 1px;
    left: 0;
    background-color: rgba(217, 122, 122, 0.4);
}

.product-mark {
    background: whitesmoke;
    border-radius: 10px;
    border-color: black;
    border-style: solid;
    border-width: 2px;
    width: 21px;
    height: 21px;
    position: absolute;
    z-index: 10000;
    text-align: center;
    pointer-events: none
}

.product-mark::before,
.product-mark::after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: 2px; /* Dicke der X-Linie */
    height: 100%;
    background-color: black;
    transform-origin: center;
}

.product-mark::before {
    transform: translateX(-50%) rotate(45deg);
}

.product-mark::after {
    transform: translateX(-50%) rotate(-45deg);
}


.filepond--action-process-item, .filepond--credits {
    display: none !important;
}
</style>
